export default __webpack_public_path__ + "static/media/sukaniLogoEnglish.308760a1.png";